import { render, staticRenderFns } from "./TrafficRequest.vue?vue&type=template&id=4dc5d6ba&scoped=true"
import script from "./TrafficRequest.vue?vue&type=script&lang=ts"
export * from "./TrafficRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5d6ba",
  null
  
)

export default component.exports